export default __webpack_public_path__ + "static/media/Eth.b7785a6d.svg";